import React from 'react';

import { env, meta } from '~/commons/config';
import useQuery from '~/commons/hooks/useQuery';
import { useHistory, useLocation } from 'react-router-dom';

import Tabs from '../../app/components/layout/Tabs.jsx';
import Articles from './Articles.jsx';

const PageAssignments = () => {
  const defaultKey = Object.keys(env.subjects)[0];

  const history = useHistory();
  const { subject: q } = useQuery();
  const loc = useLocation();
  const subject = q || defaultKey;

  meta.set({ title: '閱讀材料' });

  return (
    <div>
      <Tabs
        tabs={Object.keys(env.subjects)
          .filter(key=>key!='samples')
          .map((key) => ({
          key, label: env.subjects[key].zhhk,
        }))}
        active={subject}
        onChange={(s) => {
          history.push(`${loc.pathname}?subject=${s}`);
        }}
      />
      <Articles filter={{ subjects: subject }} />
    </div>
  );
};

export default PageAssignments;
